import { green, white } from '@/shared/styles/colors';
import styled from '@emotion/native';
import { IsDesktopProps } from '@/shared/styles/types';
import { TextInput } from 'react-native-paper';
import { AsterisksText, BaseText } from '@/shared/components/StyledText';

export const Input = styled(TextInput)<IsDesktopProps>(({ isDesktop }) => ({
  borderRadius: 40,
  height: isDesktop ? 56 : 50,
  width: '100%',
  marginBottom: 24,
  backgroundColor: white,
  textTransform: 'uppercase',
}));

export const InputLabel = styled(BaseText)({
  backgroundColor: white,
  color: green,
  paddingHorizontal: 8,
  marginLeft: -8,
  letterSpacing: 0.94,
});

export const OnboardingSideContainer = styled.View<IsDesktopProps>(
  ({ isDesktop }) => ({
    padding: isDesktop ? 40 : 0,
  }),
);

export const FieldTitle = styled(AsterisksText)<{
  marginBottom?: number;
  fontSize?: number;
}>(({ marginBottom, fontSize = 16 }) => ({
  fontWeight: 'normal',
  fontSize,
  ...(marginBottom && {
    // default to AsterisksText margin bottom if not provided
    marginBottom,
  }),
}));

export const FlexCenterScreen = styled.View({
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});
